import * as React from 'react';

/**
 * Hoc for omit props
 */
const omitProps = (...propsToOmit) => (Component) => {
    const withOmitedProps = (props) => {
        const filteredProps = {};
        Object.keys(props).forEach((propName) => {
            if (!propsToOmit.includes(propName)) {
                filteredProps[propName] = props[propName];
            }
        });
        return React.createElement(Component, { ...filteredProps });
    };
    if (typeof Component === 'string') {
        withOmitedProps.displayName = `WithOmitedProps(${'Component'})`;
    }
    else {
        withOmitedProps.displayName = `WithOmitedProps(${Component.displayName || 'Component'})`;
    }
    return withOmitedProps;
};

export { omitProps };
